import { Button } from 'reactstrap'
import s from './ImpersonationBanner.scss'
import { getUser, getImpersonatorEmail } from 'utils/authService'

const ImpersonationBanner = ({ onExitImpersonation }) => {
  const impersonatedUser = getUser()
  const impersonatorEmail = getImpersonatorEmail()

  return (
    <div className={s.impersonationBanner}>
      <span>
        You are viewing as <strong>{impersonatedUser?.name || impersonatedUser?.sub}</strong>
        {impersonatorEmail && ` (Admin: ${impersonatorEmail})`}
      </span>
      <Button color="danger" size="sm" onClick={onExitImpersonation}>
        Exit Impersonation
      </Button>
    </div>
  )
}

export default ImpersonationBanner
